import type { ParsedRecord } from "@/features/patient/records/api/dataPipelineApi";

// Deliberately a small, widget-only shape — not the full LabResult type
// (src/shared/types/index.ts), which needs per-component lab values and
// provider/facility detail a DiagnosticReport alone doesn't carry. This is
// just what the Dashboard's Recent Labs preview card actually renders.
export interface RecentLabItem {
  id: string;
  name: string;
  date: string;
  type: string;
}

/** Raw (sortable) date string for a report — issued_date if present, else
 *  effective_date. Used to sort "most recent first" before slicing to the
 *  widget's preview count; kept separate from the formatted display date. */
export function recentLabSortDate(record: ParsedRecord): string {
  const f = record.fields;
  return (f.issued_date as string) || (f.effective_date as string) || "";
}

function formatDisplayDate(value: string): string {
  const str = value.slice(0, 10);
  const [year, month, day] = str.split("-").map(Number);
  if (!year || !month || !day) return "Unknown date";
  const months = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
  return `${months[month - 1]} ${day}, ${year}`;
}

export function adaptRecentLab(record: ParsedRecord): RecentLabItem {
  const f = record.fields;
  const name = (f.display_name as string) || (f.code as string) || "Diagnostic report";
  const date = formatDisplayDate(recentLabSortDate(record));

  const contentType = typeof f.attachment_content_type === "string" ? f.attachment_content_type : "";
  const category = typeof f.category === "string" ? f.category : "";
  const type = contentType.includes("pdf")
    ? "PDF"
    : contentType.includes("image")
    ? "Image"
    : category
    ? category.charAt(0).toUpperCase() + category.slice(1)
    : "Report";

  return { id: record.id, name, date, type };
}
